module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "app-header-wrap"
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('el-dialog', {
    staticClass: "contract dialog",
    attrs: {
      "top": "70px",
      "visible": _vm.contract.show,
      "before-close": _vm.closeContract,
      "close-on-click-modal": false
    }
  }, [_c('h4', {
    staticClass: "dialog__title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.contract.title))]), _vm._v(" "), _c('div', {
    staticClass: "contract__dialog-body",
    domProps: {
      "innerHTML": _vm._s(_vm.contract.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "dialog__footer__confirm-btn",
    on: {
      "click": _vm.closeContract
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "success-modal",
    attrs: {
      "top": "23%",
      "visible": _vm.successModal.show,
      "before-close": _vm.closeSuccessMessage,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeReload
    }
  }, [_c('div', {
    staticClass: "success-modal__text"
  }, [_vm._v(_vm._s(_vm.successModal.content))])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "fail-modal",
    attrs: {
      "top": "23%",
      "visible": _vm.failModal.show,
      "before-close": _vm.closeFailMessage,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "fail-modal__text"
  }, [_vm._v(_vm._s(_vm.failModal.content))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f2789bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1074
// module chunks = 1